import { ActionHistoryModel } from "app/intake/actions/models/action-history.model";
import { CalamityActionNoteModel } from "./calamity-action-note.model";

export class CalamityActionModel {
    claId : string ;
    claCalamityId : string= null;
    claRoleCodeId : string= null;
    claActionType : string = null;
    claFollowUpDate  : Date = null;
    claFreeText : string = null;
    claStatus : string = null;
    claCreatedDate : Date = null;
    claCreatedBy : string = null;
    claLastModifiedDate : Date = null;
    claLastModifiedBy : string = null;
    contactWith : string = null;
    associatedToHelpPlan : string = null;
    comment : string = null;
    helpPlan : string = null;
    managedBy: string = null;
    claClosedDateAndTime:Date = null;
    calamityActionLogHistories: ActionHistoryModel[] = [];
    calamityActionNotes: CalamityActionNoteModel[] = [];
  }